<div class="cnt-hero-wrapper" *ngIf="photoElement?.photos?.length > 0">
  <ng-container *ngIf="photoElement?.photos?.length >= 3">
    <div class="hero-image">
      <img [src]="photos[0]" [alt]="photoElement.photos[0]?.caption" />
    </div>
    <div class="secondary-image-wrapper">
      <div class="secondary-image" *ngFor="let i of [1, 2]">
        <img [src]="photos[i]" [alt]="photoElement.photos[i]?.caption" />
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="photoElement?.photos?.length < 3">
    <img [src]="photos[0]" [alt]="photoElement.photos[0]?.caption" class="single-hero-image" />
  </ng-container>
  <button (click)="openModal()" type="button" class="cnt-button-secondary hero w-button">View Photos</button>
  <curbnturf-save-favorite [point]="point" [boondockPoint]="boondockPoint" [icon]="true" size="large">
  </curbnturf-save-favorite>
</div>
